module.exports = __webpack_public_path__ + "img/bgmain.4956ec40.jpg";